import React from 'react'
import { ExpandLess as ExpandLessIcon } from '@mui/icons-material'
import { IconButton } from '@the-platform-group/component-library'

/**
 * Custom Detail Panel Toggle Component
 * @param {boolean} isExpanded - Whether the panel is expanded
 * @returns {React.Component} - The CustomDetailPanelToggle component that toggles the expanded panel
 */
export default function CustomDetailPanelToggle({ isExpanded }) {
  return (
    <IconButton
      size="small"
      aria-label={isExpanded ? 'Close' : 'Open'}
      sx={{ borderRadius: 2, border: '1px solid', padding: 0.25 }}
    >
      <ExpandLessIcon
        fontSize="inherit"
        sx={{
          transform: isExpanded ? 'none' : 'rotate(180deg)',
          transition: 'transform 0.4s',
        }}
      />
    </IconButton>
  )
}
